// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductDescription_wrapper__3m_eS"};